<template>
  <div style="height: 100%; width: 100%;">
    <div class="header">
      <div class="title-container">
        <h3>Tableau de bord</h3>
      </div>
    </div>
    <div class="cards-container">
      <b-card class="border-0"
        style="background-color: #323232; width: 35%; height: 150px; color: #fff; margin-top: 20px; margin-left: 20px;box-shadow: 0px 0px 30px 4px rgba(87,87,87,0.43);"
        :title="headerText">
        <b-card-text class="mt-1">
          <br />Voici ce qu'il se passe chez<br /><b>{{ thirdpartyNameCookie }}</b>
        </b-card-text>
      </b-card>
      <b-card class="border-0"
        style="max-height: 50%; background-color: #323232; width: 45%; color: #fff; margin-top: 20px; margin-left: 20px; box-shadow: 0px 0px 30px 4px rgba(87,87,87,0.43);"
        title="Dernières entrées et sorties">
        <b-overlay variant="dark" :show="loading" rounded="sm">
          <b-card-text class="mt-1">
            <br />
            <b-container class="employee-list">
              <b-row>
                <b-col>Employé</b-col><b-col>Heure</b-col><b-col>Entrée/Sortie</b-col>
              </b-row>
            </b-container>
            <b-container class="employees-list" v-for="event in PointageEvents" :key="event.id">
              <b-row
                style="height: 60px; padding-left: 20px; background-color: #313131; display: flex; align-items: center; border-left: none; border-right: none; border-top: #fff; border-bottom: #fff;">
                <b-col style="cursor: pointer;" @click="navigateToEmployeeDetails(event.userownerid)">{{
          event.userFirstName }} {{ event.userLastName }}</b-col><b-col>{{ formatDate(event.datep) }}</b-col><b-col><i
                    v-if="event.label == 'Pointage sortie'" class="far fa-arrow-alt-circle-up"
                    style="color: #c5000f;"></i><i v-if="event.label == 'Pointage entrée'"
                    class="far fa-arrow-alt-circle-down" style="color: #2dd55b;"></i></b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-overlay>
      </b-card>
      <b-card class="border-0 text-center"
        style="background-color: #323232; width: 20%; height: 150px; color: #fff; margin-top: 20px; margin-left: 20px;box-shadow: 0px 0px 30px 4px rgba(87,87,87,0.43);">
        <h4>Employés présents</h4>
        <p>{{ presentEmployees.length }}</p>
        <!-- <canvas id="dailyHoursChart"></canvas> -->
      </b-card>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as moment from 'moment';
import script from '../../script/script.js';
import script_pointage from '../../script/script_pointage'
import config from '../../config/config'
import { jwtDecode } from 'jwt-decode'


export default {
  setup() {

    const presentDeleteAlert = async (itemId) => {
      const alert = await this.alertController.create({
        header: 'Êtes-vous sûr ?',
        buttons: [
          {
            text: 'Annuler',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: 'Confirmer',
            handler: () => {
              this.DeleteActu(itemId);
            },
          },
        ],
      });
      await alert.present();

    };

    onMounted(async () => {
      this.verifyRight();
    });

    return {
      eventList,
      filtereventList,
      openModalAdd,
      openModalEdit,
      presentDeleteAlert,
      DeleteActu,
    };
  },
  data() {
    return {
      activeName: 'first',
      thirdpartyNameCookie: '',
      PointageEvents: [],
      presentEmployees: [],
      jwt: '',
      decodedJwt: '',
      loading: false,
    }
  },

  async created() {
    this.thirdpartyNameCookie = await this.getCookie('thirdpartyName');
    await this.displayPointageEvents()
    this.presentEmployees = await this.displayPresentUsers()
  },

  methods: {

    verifyRight: script.verifyRight,
    getPointageEvents: script_pointage.getPointageEvents,
    getUserById: script_pointage.getUserById,
    getPresentUsers: script_pointage.getUsers,

    handleClick(tab, event) {
      console.log(tab, event);
    },

    navigateToEmployeeDetails(id) {
      this.$router.push({ name: 'details-employes', params: { id: id } });
    },

    async getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);

        }
      }
      return "";
    },

    async displayPointageEvents() {
      this.loading = true;  // Commencer le chargement

      let pointageEvents = await this.getPointageEvents();
      pointageEvents = pointageEvents.slice(0, config.nbPointageEventDisplayed);

      pointageEvents.sort((a, b) => {
        return new Date(b.datec) - new Date(a.datec);
      });

      const updatedEvents = await Promise.all(pointageEvents.map(async (event) => {
        if (event.userownerid) {
          let user = await this.getUsersById(event.userownerid);

          if (!event.datep || event.datep === "") {
          event.datep = event.datec;
        }

          event.userFirstName = user.firstname;
          event.userLastName = user.lastname;

        }
        return event;
      }));

      this.PointageEvents = updatedEvents;
      console.log(this.PointageEvents);

      this.loading = false;  // Terminer le chargement
    },


    async getUsersById(id) {
      let user = await this.getUserById(id);
      return user
    },

    async displayPresentUsers() {
      let users = await this.getPresentUsers();
      return users.filter(user => user.array_options.options_travail_en_cours === "1")
    },

    formatDate(timestamp) {
      const date = new Date(timestamp*1000);

      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
  },




  computed: {
    info() {
      return this.$store.state.info;
    },
    headerText() {
      return 'Bonjour ' + this.$store.state.info.prenom + " " + this.$store.state.info.nom;
    }
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 60px;
  background-color: #333;
  display: flex;
  justify-content: start;
  align-items: center;
  border-bottom: 0.1px solid #bcbcbc;
}

.title-container {
  margin-left: 20px;
}

.title-container h3 {
  color: #fff;
}

.cards-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100% - 60px);
  background-color: #3f3f3f;
}

.col {
  color: #fff;
  font-size: medium;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
